import type { DependencyState } from "@wishlink/applens-core";
import type { dependencyState as DependencyRule } from "@wishlink/applens-core";
import type { QueryTiming } from "./dependencies";

export interface IntentSnapshot {
  /** True only for the TEST bucket whose intent query is enabled. */
  enabled: boolean;
  query?: QueryTiming;
}

const rank = { absent: 0, cache: 1, inflight: 2, network: 3 };

/** Creator intent gate uses the shared dependency rule; CONTROL stays absent. */
export function createIntentDependency(
  homeEpoch: number,
  initial: IntentSnapshot,
  dependencyState: typeof DependencyRule
) {
  const first =
    initial.enabled && initial.query ? { ...initial.query } : undefined;
  let value = dependencyState(first, homeEpoch, true);
  return (latest: IntentSnapshot): { "app.dep.intent": DependencyState } => {
    // A skipped CONTROL query must not pick up data left in the shared RTK cache.
    if (!latest.enabled) return { "app.dep.intent": "absent" };
    const unchanged =
      first?.startedTimeStamp !== undefined &&
      first.startedTimeStamp === latest.query?.startedTimeStamp;
    const next = dependencyState(latest.query, homeEpoch, unchanged);
    if (rank[next] > rank[value]) value = next;
    return { "app.dep.intent": value };
  };
}
